import { ProfileIcon } from "../../../atoms/icons/profile";
import React from "react";

export const Profile = ({ display }) => {
  return (
    <div className="irq-nav-wrapper bold">
      <ProfileIcon
        className="profile-icon-margin"
        fill="white"
        width="30"
        height="30"
      />

      <span className={`${display ? "" : "top-stats-text"}`}>Profile</span>
    </div>
  );
};
